// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__qDsDk","row":"styles_row__3nm4w"};